import {
  PURCHASE_URL,
  REGWIZ_URL,
  ACCOUNT_URL,
} from './env';

/**
 * CONSTS
 */
const GUID_NOT_RECEIVED = 'GUID_NOT_RECEIVED';
const CAN_POST_MESSAGE = !!(window.opener && window.opener !== window);
const WEBGUI_PARENT = CAN_POST_MESSAGE ? window.opener.parent : window.parent; // for postMessage event listeners and senders
const ALLOWED_ORIGINS = [
  PURCHASE_URL,
  REGWIZ_URL,
  ACCOUNT_URL,
  'https://localhost:8008',
  'https://launchpad.unraid.test:8081',
  'https://launchpad.unraid.test:6969',
  'https://registration.unraid.net',
  'https://registration-dev.unraid.net',
  'https://registration-dev-logs.unraid.net',
  'https://unraid.net',
  'https://staging.unraid.net',
  'https://craft.unraid.test',
];

const ERROR_MESSAGE_UNEXPECTED_OWNER_RESPONSE = 'API error unexpected response for "owner".';

/**
 * @method: OPEN_POPUP
 * @description: Creates a pop-up window on demand
 * @param: {string} url - URL of window
 * @param: {string} name - name of window
 * @param: {number} w - width of window
 * @param: {number} h - height of window
 * @see: https://stackoverflow.com/a/16861050/3215809 let's not reinvent the wheel
 */
const OPEN_POPUP = (url, name, w, h) => {
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
  /* eslint-disable */
  const width = window.innerWidth ? window.innerWidth : (document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width);
  const height = window.innerHeight ? window.innerHeight : (document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height);
  /* eslint-enable */
  const systemZoom = width / window.screen.availWidth > 1 ? width / window.screen.availWidth : 1; // min set to 1 as it fixed window sizes being huge
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;
  // make it easier. Auto flatten into the correct string format: '{key}={value},{key}={value},…'
  const args = Object.entries({
    toolbar: 'no',
    location: 'yes',
    status: 'no',
    menubar: 'no',
    scrollbars: 'yes',
    resizable: 'yes',
    width: (w / systemZoom),
    height: (h / systemZoom),
    top,
    left,
  })/* eslint-disable */
    .reduce((a, b) => a += `${b[0]}=${b[1]},`, '');
    /* eslint-enable */

  return window.open(
    url,
    name,
    args,
  );
};

/* eslint-disable  */
const REMOVE_EMPTY = (obj) => {
  Object.entries(obj).forEach(([key, val]) =>
    (val && typeof val === 'object') && REMOVE_EMPTY(val) ||
    (val === null || val === "") && delete obj[key]
  );
  return obj;
};
/* eslint-enable */
/**
 * @name SAFE_JSON_PARSE
 * @param {string} str
 * @example
const [err, data] = SAFE_JSON_PARSE(e.data);
if (err) return;
switch (data)
…
 */
const SAFE_JSON_PARSE = (str) => {
  try {
    return [null, JSON.parse(str)];
  } catch (err) {
    return [err];
  }
};
/**
 * @name OBJ_TO_STR
 * @param {object} obj
 * @returns {String}
 * @description Output key + value for each item in the object. Adds new line after each item.
 */
const OBJ_TO_STR = obj => Object.entries(obj).reduce((str, [p, val]) => `${str}${p}: ${val}\n`, '');

const X_ENV_KEY = 'x-env-unraid-api';

const ERROR_CORS_403 = 'The CORS policy for this site does not allow access from the specified Origin';

export {
  GUID_NOT_RECEIVED,
  CAN_POST_MESSAGE,
  WEBGUI_PARENT,
  ALLOWED_ORIGINS,
  ERROR_MESSAGE_UNEXPECTED_OWNER_RESPONSE,
  OPEN_POPUP,
  REMOVE_EMPTY,
  SAFE_JSON_PARSE,
  OBJ_TO_STR,
  X_ENV_KEY,
  ERROR_CORS_403,
};
